import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidWorkflowQuery,
  WorkflowStageSearchRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../../utils";

// Cannot generate this from the graphql backend because the transition group enum
// must be of string type to use unified logic and also accept custom stages later
// on when we add that functionality.
export enum BidWorkflowTransitionGroup {
  ToQualify = "To_qualify",
  In_progress = "In_Progress",
  Submitted = "Submitted",
  Disqualified = "Disqualified",
  Won = "Won",
  Lost = "Lost",
}

const BID_WORKFLOW_QUERY = graphql(`
  query bidWorkflow(
    $withCounts: Boolean!
    $withStageValueSum: Boolean!
    $stageFilterRequest: WorkflowStageSearchRequest
  ) {
    bidWorkflow {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
          bidCount(WorkflowStageSearchRequest: $stageFilterRequest) @include(if: $withCounts)
          bidValueSum(WorkflowStageSearchRequest: $stageFilterRequest)
            @include(if: $withStageValueSum)
        }
      }
    }
  }
`);

type UseBidWorkflowOptions = {
  withCounts?: boolean;
  stageFilterRequest?: WorkflowStageSearchRequest;
  withStageValueSum?: boolean;
};

export type BidWorkflow = BidWorkflowQuery["bidWorkflow"];

export function useBidWorkflow(
  { withCounts = false, withStageValueSum = false, stageFilterRequest }: UseBidWorkflowOptions = {},
  options?: UseQueryOptions<BidWorkflowQuery, unknown, BidWorkflowQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["bidWorkflow", withCounts, withStageValueSum, stageFilterRequest],
    BID_WORKFLOW_QUERY,
    [{ withCounts, withStageValueSum, stageFilterRequest: stageFilterRequest ?? {} }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );
  return { ...rest, data: data?.bidWorkflow };
}
